import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

export const tariffTypeApiSchema = v.object({
  codeDesc: v.string(),
  codeId: v.optional(v.string()),
  id: v.number(),
  lookupCodeType: v.string(),
  string2: v.pipe(
    v.nullish(v.string()),
    v.transform((value) => value ?? undefined),
  ),
});

export const tariffTypeSchema = v.object({
  ...tariffTypeApiSchema.entries,
  ...optionSchema.entries,
  string2: v.optional(v.string()),
});

export const tariffTypesApiSchema = paginatedSchema(tariffTypeApiSchema);

export type TariffTypeApi = v.InferOutput<typeof tariffTypeApiSchema>;
export type TariffTypesApi = v.InferOutput<typeof tariffTypesApiSchema>;

export type TariffTypeFilters = Filters<TariffTypeApi>;

export type TariffTypeFiltersUpdateApi = FiltersUpdateApi<TariffTypeApi>;

export type TariffType = Prettify<Option<v.InferOutput<typeof tariffTypeSchema>>>;

export type TariffTypes = Entities<TariffType>;
